import { render, staticRenderFns } from "./UiInputTextBubble.vue?vue&type=template&id=00b87503&scoped=true"
import script from "./UiInputTextBubble.vue?vue&type=script&lang=js"
export * from "./UiInputTextBubble.vue?vue&type=script&lang=js"
import style0 from "./UiInputTextBubble.vue?vue&type=style&index=0&id=00b87503&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b87503",
  null
  
)

export default component.exports